<template>
  <content-box class="change-plan--wrap" :width="'530px'">
    <template v-if="!topUpJam">
      <p class="title">
        {{ $t('common.chargePv') }}
      </p>
      <div class="plan-type--wrap">
        <div class="plan-type" :class="paymentType">
          <!-- <button type="button"
                  class="card"
                  :class="{on: paymentType === 'card'}"
                  :style="{opacity: ($i18n.locale !== 'ko' && paymentType !== 'card') ? 0.5 : 1}"
                  @click="onSelectPaymentType('card')">
            {{ $t('payment.card') }}
          </button> -->
          <button type="button"
                  class="enterprise"
                  :class="{on: paymentType === 'wireTransfer'}"
                  @click="onSelectPaymentType('wireTransfer')">
            {{ $t('payment.wire') }}
          </button>
          <button type="button"
                  class="jam"
                  :class="{on: paymentType === 'jam'}"
                  @click="onSelectPaymentType('jam')">
            {{ $t('payment.jam') }}
          </button>
        </div>
      </div>
      <div class="plan-info--wrap" :class="{ nojam: planInfoSelector === 'noJam' }">
        <template v-if="planInfoSelector === 'notJam'">
          <div class="pv-price">
            <p class="label">
              <strong>{{ pvAmount | thousand }}</strong> PV
              <span class="period">
                {{ $t('common.subscriptionTerms') }}: {{ period.start | dashDate }} ~ {{ period.end | dashDate }}
              </span>
            </p>
            <div class="value">
              <p>{{ $t('payment.currency') }}{{ pvPrice | thousand }}</p>
              <span>({{ $t('payment.noVat') }})</span>
            </div>
          </div>
          <div class="pv-button">
            <ui-button :iconName="'icon--minus-black'"
              :size="'large'"
              :disabled="chargeAmount === 1"
              @click="setChargeAmount(-1)">
            </ui-button>
            <input class="pv-text" type="'text'" v-model="chargeAmount" @input="setChargeAmount" />
            <ui-button :iconName="'icon--plus-black'" :size="'large'" @click="setChargeAmount(1)" />
          </div>
        </template>
        <template v-if="planInfoSelector === 'jamRemain'">
          <div class="pv-price">
            <p class="label">
              <strong>{{ jamAmount | thousand }}</strong> PV
              <span class="period">
                {{ $t('common.subscriptionTerms') }}: {{ period.start | dashDate }} ~ {{ period.end | dashDate }}
              </span>
            </p>
            <div class="value">
              <p>{{ jamPrice | thousand }} {{ $t('plan.jamAmount') }}</p>
            </div>
          </div>
          <div class="jam-button">
          <ui-button :iconName="'icon--minus-black'" :size="'large'" :disabled="jamUseAmount === 5" @click="setJamUseAmount(-5)" />
          <input class="jam-text" type="'text'" :disabled="true" v-model="jamUseAmount"/>
          <span class="remainjam">/{{ remainJam | thousand }}</span>
          <div class="icon icon--jam--24px"></div>
          <ui-button :iconName="'icon--plus-black'" :size="'large'" :disabled="jamUseAmount > remainJam - 1" @click="setJamUseAmount(5)" />
          <ui-button class="btn__jam" :size="'large'" @click="onOpenTopUpJamLayer">{{ $t('plan.chargeJam') }}</ui-button>
          </div>
        </template>
        <template v-if="planInfoSelector === 'noJam'">
          <span>{{ $t('plan.noJam.description') }}</span>
          <div class="icon icon--no-jam"></div>
          <ui-button class="btn__jam" :size="'large'" @click="onOpenTopUpJamLayer">{{ $t('plan.chargeJam') }}</ui-button>
        </template>
      </div>
      <div v-if="planInfoSelector !== 'noJam'" class="notice--wrap">
        <ul>
          <li>
            <p>{{ $t('plan.chargePv.minimumAmount') }}</p>
          </li>
          <li>
            <p>{{ $t('plan.chargePv.reloadedImmediately') }}</p>
          </li>
          <li v-if="planInfoSelector !=='jamRemain'">
            <p>{{ $t('plan.chargePv.unitPrice') }}</p>
          </li>
          <li v-if="planInfoSelector ==='jamRemain'">
            <p>{{ $t('plan.chargePv.unitPriceJam') }}</p>
          </li>
          <li>
            <p>{{ $t('plan.chargePv.notBeCarried') }}</p>
          </li>
        </ul>
      </div>
      <div v-else class="notice--wrap">
        <ul>
          <li>
            <p>{{ $t('plan.noJam.about') }}</p>
          </li>
          <!-- <li>
            <p>{{ $t('plan.noJam.period') }}</p>
          </li> -->
          <li>
            <p>{{ $t('plan.noJam.unitPrice') }}</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="footer-description" v-if="planInfoSelector !== 'noJam'">
          <ui-checkbox v-model="isTermsAgree" v-if="paymentType !== 'wireTransfer'" :disabled="planInfoSelector === 'jamRemain' && remainJam < 5">
            <span class="terms-agree">
              {{ $t('plan.agree') }}
            </span>
          </ui-checkbox>
          <span class="terms-agree" v-else v-html="$t('plan.wireDescription')">

          </span>
        </div>
        <span v-if="hasTermsError" class="terms-agree-validation-text">{{ $t('common.validationErrorText.requiredAgree') }}</span>
        <div class="button--wrap">
          <ui-button class="btn__cancel" @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <!-- <ui-button class="btn__confirm" :primary="true" @click="onConfirm" :disabled="!isTermsAgree"
            v-if="paymentType === 'card' && $i18n.locale === 'ko'">
            {{ $t('common.confirm') }}
          </ui-button> -->
          <ui-button class="btn__confirm" :primary="true" :disabled="planInfoSelector === 'noJam' || !isTermsAgree"
            @click="onConfirm('jam')" v-if="paymentType === 'jam'">
            {{ $t('common.confirm') }}
          </ui-button>
          <ui-button class="btn__confirm" :primary2="true" @click="onConfirm"
            v-if="paymentType !== 'jam' && $i18n.locale !== 'ko'">
            {{ $t('common.contact') }}
          </ui-button>
          <ui-button class="btn__confirm" :primary2="true" @click="onConfirm"
            v-if="paymentType === 'wireTransfer' && $i18n.locale === 'ko'">
            {{ $t('common.contact') }}
          </ui-button>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="title">
        {{ $t('common.chargeJam') }}
      </p>
      <div class="plan-info-topup--wrap">
        <template>
          <div class="jam-title">
            {{ $t('payment.wire') }}
          </div>
          <div class="jam-price">
            <div class="label">
              <div style="display: flex; align-items: center;">
                <div class="icon icon--jam--24px"></div>
                <strong>{{ jamChargeAmount | thousand }}</strong>
                <span style="margin-top: 5px;" class="count">{{ $t('plan.jamAmount') }}</span>
              </div>
              <span class="period">
                {{ $t('common.subscriptionTerms') }}: {{ jamPeriod.start | dashDate }} ~ {{ jamPeriod.end | dashDate }}
              </span>
            </div>
            <div class="value">
              <p>{{$t('payment.currency')}}{{ jamChargePrice | thousand }}</p>
              <span>({{ $t('payment.noVat') }})</span>
            </div>
          </div>
          <div class="jam-button">
            <ui-button
              :iconName="'icon--minus-black'"
              :size="'large'"
              :disabled="jamChargeAmount === 10"
              @click="setJamChargeAmount(-10)">
            </ui-button>
            <input class="pv-text"
              type="'text'"
              :disabled=true
              v-model="jamChargeAmount"
              @input="setJamChargeAmount" />
            <ui-button :iconName="'icon--plus-black'"
              :size="'large'"
              @click="setJamChargeAmount(10)">
            </ui-button>
          </div>
        </template>
      </div>
      <div  class="notice--wrap">
        <ul>
          <li>
            <p v-html="$t('plan.topUpJam.about')"></p>
          </li>
          <li>
            <p v-html="$t('plan.topUpJam.period')"></p>
          </li>
          <li>
            <p v-html="$t('plan.topUpJam.description')"></p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="footer-description">
          <span class="terms-agree"  v-html="$t('plan.wireDescription')">
          </span>
        </div>
        <span v-if="hasTermsError" class="terms-agree-validation-text">{{ $t('common.validationErrorText.requiredAgree') }}</span>
        <div class="button--wrap">
          <ui-button class="btn__cancel" @click="onCloseLayer">{{ $t('common.cancel') }}</ui-button>
          <ui-button class="btn__confirm"
            :primary2="true"
            @click="onConfirm('jamcharge')"
          >
            {{ $t('common.contact') }}
          </ui-button>
        </div>
      </div>
    </template>
  </content-box>
</template>

<script>
import { addDays, addMonths } from 'date-fns'
import { mapState } from 'vuex'
import { openContactUs, getLocaleDateStr, thousand } from '@/libs/utils'
import { getCardInfo } from '@/api/card'
import { onChargeJam } from '@/api/jam'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiCheckbox from '@/components/ui/UiCheckbox'

const pvUnit = 100000
const jamUnit = 20000
const pvPrice = 0.05
const jamPrice = 0.00005
const jamChargePrice = 1000
const includeVat = 1.1

export default {
  components: {
    ContentBox,
    UiButton,
    UiCheckbox
  },
  props: [
    'topUpJam',
    'remainJam'
  ],
  data () {
    return {
      hasTermsError: false,
      isTermsAgree: false,
      paymentType: 'wireTransfer',
      chargeAmount: 1,
      jamChargeAmount: 5,
      jamUseAmount: 5,
      period: {
        start: null,
        end: null
      },
      jamPeriod: {
        start: null,
        end: null
      },
      TopUpProcess: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData'
    ]),
    getTermsUrl () {
      return process.env.VUE_APP_HOME_URL + '/terms/?locale=ko'
    },
    pvAmount () {
      return pvUnit * this.chargeAmount
    },
    pvPrice () {
      if (this.$i18n.locale === 'ja') {
        return (pvPrice * this.pvAmount) / 10
      } else if (this.$i18n.locale === 'en') {
        return (pvPrice * this.pvAmount) / 1000
      } else {
        return pvPrice * this.pvAmount
      }
    },
    jamAmount () {
      return jamUnit * this.jamUseAmount
    },
    jamPrice () {
      return jamPrice * this.jamAmount
    },
    jamChargePrice () {
      if (this.$i18n.locale === 'ja') {
        return (jamChargePrice * this.jamChargeAmount) / 10
      } else if (this.$i18n.locale === 'en') {
        return (jamChargePrice * this.jamChargeAmount) / 1000
      } else {
        return jamChargePrice * this.jamChargeAmount
      }
    },
    expireDateFormat () {
      return getLocaleDateStr(addDays(this.planData.endDate, 1))
    },
    planInfoSelector () {
      if (this.paymentType !== 'jam') {
        return 'notJam'
      } else {
        if (this.remainJam) {
          return 'jamRemain'
        } else {
          return 'noJam'
        }
      }
    }
  },
  watch: {
    topUpJam: {
      handler (newValue) {
        if (newValue) {
          this.jamChargeAmount = 10
          this.jamUseAmount = 10
        }
      },
      immediate: true
    }
  },
  created () {
    const fiveYearsAfter = addMonths(new Date(), 60)
    this.period.start = new Date()
    this.jamPeriod.start = new Date()
    this.jamPeriod.end = addDays(fiveYearsAfter, -1)
    this.period.end = this.planData.monthlyEndDate
    if (this.$i18n.locale !== 'ko') {
      this.paymentType = 'wireTransfer'
    }
    if (this.topUpJam) this.paymentType = 'wireTransfer'
  },
  methods: {
    setChargeAmount (value) {
      if (value) {
        this.chargeAmount = this.chargeAmount + value
      }
      this.chargeAmount = parseInt(this.chargeAmount) || 1
      if (this.chargeAmount > 10000000) {
        this.chargeAmount = 10000000
      } else if (this.chargeAmount < 1) {
        this.chargeAmount = 1
      }
    },
    setJamUseAmount (value) {
      if (this.jamUseAmount % value > 0) value = this.jamUseAmount % value * value / 5
      this.jamUseAmount = this.jamUseAmount + value
      if (this.jamUseAmount > this.remainJam) {
        this.jamUseAmount = this.remainJam
      }
      this.jamUseAmount = parseInt(this.jamUseAmount) || 1
      if (this.jamUseAmount > 10000000) {
        this.jamUseAmount = 10000000
      } else if (this.jamUseAmount < 5) {
        this.jamUseAmount = 5
      }
    },
    setJamChargeAmount (value) {
      if (value) {
        this.jamChargeAmount = this.jamChargeAmount + value
      }
      this.jamChargeAmount = parseInt(this.jamChargeAmount) || 1
      const minAmount = this.topUpJam ? 10 : 5
      if (this.jamChargeAmount > 10000000) {
        this.jamChargeAmount = 10000000
      } else if (this.jamChargeAmount < minAmount) {
        this.jamChargeAmount = minAmount
      }
    },
    onSelectPaymentType (value) {
      if (this.$i18n.locale === 'ko') {
        this.hasTermsError = false
        this.paymentType = value
      } else {
        if (value !== 'card') {
          this.paymentType = value
        }
      }
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    onOpenTopUpJamLayer () {
      this.$emit('onTopUpJam', true)
      if (this.$i18n.locale === 'ko') {
        this.paymentType = 'wireTransfer'
      } else {
        this.paymentType = 'wireTransfer'
      }
    },
    onConfirm (type) {
      this.hasTermsError = false
      if (this.paymentType === 'wireTransfer' || (this.paymentType === 'jam' && this.$i18n.locale !== 'ko' && type === 'jamcharge')) {
        if (type !== 'jamcharge') {
          if (this.$i18n.locale === 'ko') {
            openContactUs(this.userData,
              this.$t('plan.wireForm', {
                product: this.$t('common.journeyChargePv'),
                amount: thousand(this.chargeAmount),
                pv: thousand(this.pvAmount),
                price: thousand(this.pvPrice)
              }),
              true
            )
          } else {
            openContactUs(this.userData,
              this.$t('plan.wireForm', {
                product: this.$t('common.journeyChargePv'),
                amount: thousand(this.chargeAmount),
                pv: thousand(this.pvAmount),
                price: thousand(this.pvPrice)
              }),
              true
            )
          }
        } else {
          if (this.$i18n.locale === 'ko') {
            openContactUs(this.userData,
              this.$t('plan.jamForm', {
                product: this.$t('common.chargeJam'),
                amount: thousand(this.jamChargeAmount),
                price: thousand(this.jamChargePrice)
              }),
              true
            )
          } else if (this.$i18n.locale === 'ja') {
            openContactUs(this.userData,
              this.$t('plan.jamForm', {
                product: this.$t('common.chargeJam'),
                amount: thousand(this.jamChargeAmount),
                price: thousand(this.jamChargePrice)
              }),
              true
            )
          } else {
            console.log(jamChargePrice, jamChargePrice)
            openContactUs(this.userData,
              this.$t('plan.jamForm', {
                product: this.$t('common.chargeJam'),
                amount: thousand(this.jamChargeAmount),
                price: thousand(this.jamChargePrice)
              }),
              true
            )
          }
        }
        this.onCloseLayer()
        return
      }

      if (!this.isTermsAgree) {
        this.hasTermsError = true
        return
      }
      if (type === 'jam') {
        this.$emit('onConfirm', {
          type: 'jam',
          jamCount: this.jamUseAmount,
          pvCount: 20000 * this.jamUseAmount
        })
      } else {
        this.$emit('onConfirm', {
          openTossView: true,
          price: parseInt(this.pvPrice * includeVat),
          pvCount: pvUnit * this.chargeAmount,
          serviceType: 'ba'
        })
      }
    },
    onJamTopUp () {
      getCardInfo('ba').then(data => {
        if (!data || (!data.iamportCustomerUid && !data.tossBillingKey)) {
          this.$emit('registerDataChange', { customerUid: null })
        } else {
          onChargeJam({
            jamCount: this.jamChargeAmount,
            totalPrice: parseInt((3000 * this.jamChargeAmount) * includeVat)
          }).then(res => {
            if (res.success) {
              this.$emit('remainJamChange', true)
              this.$emit('closeLayer')
              this.$emit('showTopUpAlert', true)
              this.$emit('result', true)
            } else {
              this.$emit('closeLayer')
              this.$emit('showTopUpAlert', true)
              this.$emit('result', false)
            }
          }).catch(err => {
            console.log(err)
            this.$emit('closeLayer')
            this.$emit('showTopUpAlert', true)
            this.$emit('result', false)
          })
        }
      }).catch(err => {
        console.log(err)
        this.$emit('closeLayer')
        this.$emit('showTopUpAlert', true)
        this.$emit('result', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.change-plan--wrap {
  padding: 30px 30px 25px;
  box-sizing: border-box;

  .plan-type--wrap {
    margin-top: 24px;
    text-align: center;

    .plan-type {
      display: inline-block;
      width: 470px;
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      transition: background-color 0.3s ease, border-color 0.3s ease;
      border-radius: 20px;
      position: relative;

      button {
        width: 50%;
        text-align: center;
        line-height: 36px;
        height: 36px;
        color: #888888;
        position: relative;
        font-size: 15px;
        z-index: 2;
        transition: color 0.3s ease;

        &:first-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        &:last-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        i {
          vertical-align: middle;
          transform: translateY(-1px);
          width: 0;
          transition: width 0.3s ease, margin 0.3s ease;
        }

        &.on {
          color: #ffffff;

          i {
            width: 20px;
            margin: 0 20px 0 0;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: -1px;
        left: -1px;
        background: #ec0147;
        border-radius: 20px;
        transition: left 0.3s cubic-bezier(.28,.12,.42,.94);
        display: block;
        width: 50%;
        height: 38px;
        box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
      }

      &.jam::before {
        left: 247px;
      }
    }
  }

  .plan-type-topup--wrap {
    margin-top: 24px;
    text-align: center;

    .plan-type {
      display: inline-block;
      width: 470px;
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      transition: background-color 0.3s ease, border-color 0.3s ease;
      border-radius: 20px;
      position: relative;

      button {
        width: 210px;
        text-align: center;
        line-height: 36px;
        height: 36px;
        color: #888888;
        position: relative;
        font-size: 15px;
        z-index: 2;
        transition: color 0.3s ease;
        position: relative;

        &:first-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        &:last-child {
          box-sizing: border-box;
          padding-right: 5px;
        }

        i {
          position: absolute;
          bottom: 8px;
          left: 10px;
          vertical-align: middle;
          transform: translateY(-1px);
          width: 0;
          transition: width 0.3s ease, margin 0.3s ease;
        }

        &.on {
          color: #ffffff;

          i {
            width: 20px;
            margin: 0 20px 0 0;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: -1px;
        left: -1px;
        background: #ec0147;
        border-radius: 20px;
        transition: left 0.3s cubic-bezier(.28,.12,.42,.94);
        display: block;
        width: 235px;
        height: 38px;
        box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
      }

      &.wireTransfer::before {
        left: 235px;
      }
    }
  }

  .title {
    text-align: left;
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
  }

  .plan-info--wrap {
    margin-top: 33px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;

    .pv-price {
      @include flexXbetween;
      align-items: center;

      .label {
        font-size: 16px;
        color: #ec0047;

        strong {
          font-size: 28px;
          font-weight: 500;
        }

        .period {
          font-size: 13px;
          color: #666666;
          display: block;
          margin-top: 10px;
        }
      }

      .value {
        text-align: right;
        p {
          font-size: 16px;
          font-weight: 500;
          color: #2f2f2f;
        }
        span {
          display: inline-block;
          font-size: 12px;
          color: #444444;
          margin-top: 8px;
        }
      }
    }

    .pv-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      text-align: center;

      .pv-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }
    }
    .jam-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      display: flex;
      align-items: center;
      position: relative;

      .jam-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }

      .remainjam {
        font-size: 16px;
        color: #2f2f2f;
      }

      .icon--jam--24px {
        width: 20px;
        height: 20px;
        margin: 0px 7px;
      }

      .btn__jam {
        position: absolute;
        min-width: 85px;
        padding: 0 15px;
        right: 0;
      }
    }
    .icon--no-jam {
        margin: 15px 0;
        width: 165px;
        height: 130px;
      }
  }

  .plan-info-topup--wrap {
    margin-top: 33px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    .jam-title {
      font-size: 13px;
      color: #444;
      font-weight: 500;
      margin-bottom: 13px;
    }
    .jam-price {
      @include flexXbetween;
      align-items: center;

      .label {
        font-size: 16px;
        color: #ec0047;

        strong {
          margin-left: 10px;
          font-size: 28px;
          font-weight: 500;
        }

        .count {
          margin-left: 10px;
        }

        .period {
          font-size: 13px;
          color: #666666;
          display: block;
          margin-top: 10px;
        }

        .icon--small-jam {
          width: 24px;
          height: 24px;
        }
      }

      .value {
        text-align: right;
        p {
          font-size: 16px;
          font-weight: 500;
          color: #2f2f2f;
        }
        span {
          display: inline-block;
          font-size: 12px;
          color: #444444;
          margin-top: 8px;
        }
      }
    }

    .jam-button {
      border-top: 2px solid #c1c1c1;
      margin-top: 30px;
      padding-top: 25px;
      text-align: center;

      .pv-text {
        -webkit-appearance: none;
        width: 70px;
        height: 38px;
        border-radius: 6px;
        border: 1px solid #289eef;
        background-color: #ffffff;
        vertical-align: middle;
        text-align: center;
        font-size: 16px;
        color: #2f2f2f;
        margin: 0 5px;
      }

      button {
        min-width: 0;
        padding-right: 2px;
        vertical-align: middle;
      }
    }
  }

  .nojam {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .notice--wrap {
    text-align: left;
    margin-top: 25px;

    ul > li {
      position: relative;
      padding-left: 20px;
      font-size: 13px;
      line-height: 1.46;
      color: #666666;

      &:before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: #888;
        position: absolute;
        top: 7px;
        left: 10px;
      }

      &:not(:first-child) {
        margin-top: 10px;
      }

      ol {
        margin-top: 10px;

        li {
          @include flexXbetween;

          &:not(:first-child) {
            margin-top: 5px;
          }

          button {
            font-size: 12px;
            font-weight: 500;
            text-align: right;
            color: #555555;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid #d8d8d8;
    text-align: center;
    position: relative;

    .footer-description {
      line-height: 16px;
      height: 16px;
    }

    .button--wrap {
      margin-top: 40px;

      button {
        min-width: 86px;
      }

      .btn__confirm {
        margin-left: 5px;
      }
    }

    .ui_checkbox {
      margin-left: 0;
    }
    .terms-agree {
      position: relative;
      text-align: left;
      font-size: 13px;
      color: #2f2f2f;
    }
    .terms-agree-validation-text {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 13px;
      color: $brandColor;
      white-space: nowrap;
      display: inline-block;
    }
  }
}
</style>
